<template>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow">
        <!-- Modal de espera con animación y spinner -->
        <v-dialog v-model="mostrarModal" max-width="300">
            <v-card>
                <v-card-title>
                <span class="headline">Por favor, espere...</span>
                </v-card-title>
                <v-card-text>
                    <v-container class="text-center">
                        <v-row>
                            <v-col>
                                <v-progress-circular
                                indeterminate
                                color="primary"
                                ></v-progress-circular>
                            </v-col>
                        </v-row>
                         
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    export default {
    data() {
        return {
        mostrarModal: false,
        };
    },
    };
</script>
